import React, { useState, useContext } from 'react';
import ReactHtmlParser from 'react-html-parser';

// Components
import SignUpForm from '../components/Form/SignUpForm';
import Topic from "../components/Topic/Topic";
import StreamVideoPopup from "../components/Popup/StreamVideoPopup";
import { useTogglePopup } from '../utils/useTogglePopup';
import { ApiContext } from '../context/api/apiContext';

// Assets
import PlayIcon from '../i/icons/play.svg';

export const HowItWorks = () => {
	const [isPopupOpen, showPopup, hidePopup] = useTogglePopup();
	const { jsonData } = useContext(ApiContext);

	const {
		heroSection,
		streamSection,
		connectSection,
		signUpSection,
		topicList
	} = jsonData.pages.howItWorks;

	return (
		<React.Fragment>
			<section className="section hero_v1_mod center_level_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${heroSection.bgImage})` }} />
				<div className="section_in inner_hero_v2_mod">
					<h2 className="section_title hero_mod center_level_mod hero_v2_mod">{heroSection.title}</h2>
					<a
						className="hero_play_btn btnOpenStreamVideo"
						href="#"
						onClick={showPopup}
					>
						<div className="hero_play_icon">
							<PlayIcon className="icon icon-play play_mod white_mod size_mod" />
						</div>
					</a>
					<div className="hero_title">{heroSection.subtitle}</div>
					<div className="section_descr hero_mod center_mod">
						<p>{heroSection.description}</p>
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in limit_mod">
					<div className="content_banner">
						<div className="content_banner_img_w">
							<img className="content_banner_img" src={streamSection.contentImg} alt={streamSection.contentImgAlt} />
						</div>
						<div className="content_banner_text_w">
							<h2 className="section_title accent_mod height_mod offset_mod">{streamSection.title}</h2>
							<h3 className="section_subtitle accent_mod">{streamSection.subtitle}</h3>
							<div className="section_descr accent_mod height_mod">{streamSection.description}</div>
						</div>
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<div className="topic_list">
						{topicList.map(({name, description}, index) => {
							return (
								<div className="topic_item_wrap" key={index}>
									<Topic
										name={name}
										descr={description}
									/>
								</div>
							)
						})}
					</div>
				</div>
			</section>
			<section className="section no_offset_top">
				<div className="section_in">
					<SignUpForm
						title={signUpSection.title}
						buttonTitle={signUpSection.buttonTitle}
					/>
				</div>
			</section>
			<section className="section info_mod center_level_mod double_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${connectSection.bgImage})` }} />
				<div className="section_in limit_mod">
					<div className="section_block">
						<h2 className="section_title offset_mod">{ReactHtmlParser(connectSection.title)}</h2>
						<div className="section_descr offset_mod darken_mod">{ReactHtmlParser(connectSection.description)}</div>
						<a className="btn_base" href={connectSection.buttonUrl}>{connectSection.buttonTitle}</a>
					</div>
				</div>
			</section>
			{
				isPopupOpen ?
					<StreamVideoPopup hidePopup={hidePopup} /> : false
			}
		</React.Fragment>
	);
}
export default HowItWorks;